var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13 26.0046C13.4926 26.0046 13.9638 25.9832 14.4349 25.9189C9.33773 25.2976 5.39703 20.9484 5.39703 15.6994C5.39703 10.0006 10.0016 5.39431 15.6985 5.39431C20.9456 5.39431 25.2932 9.3364 25.9143 14.4354C25.9572 13.9641 26 13.4927 26 13C26 5.8228 20.1746 -0.00463867 13 -0.00463867C5.82537 -0.00463867 0 5.80137 0 13C0 20.1986 5.82537 26.0046 13 26.0046Z",
    fill: "#0000FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13 -0.00463867C12.5074 -0.00463867 12.0362 0.016786 11.5651 0.0810592C16.6623 0.702367 20.603 5.05152 20.603 10.3005C20.603 15.9994 15.9984 20.6056 10.3015 20.6056C5.05437 20.6056 0.706753 16.6635 0.0856659 11.5645C0.0428323 12.0359 0 12.5072 0 13C0 20.1771 5.82537 26.0046 13 26.0046C20.1746 26.0046 26 20.1771 26 13C26 5.8228 20.196 -0.00463867 13 -0.00463867Z",
    fill: "#8CC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M26 13C26 12.5072 25.9786 12.0359 25.9143 11.5645C25.2932 16.6635 20.9456 20.6056 15.6985 20.6056C10.0016 20.6056 5.39703 15.9994 5.39703 10.3005C5.39703 5.05152 9.33773 0.702367 14.4349 0.0810592C13.9638 0.0382104 13.4926 -0.00463867 13 -0.00463867C5.82537 -0.00463867 0 5.8228 0 13C0 20.1771 5.82537 26.0046 13 26.0046C20.1746 26.0046 26 20.1771 26 13Z",
    fill: "#C1272D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M0 13C0 13.4927 0.0214155 13.9641 0.0856659 14.4354C0.706753 9.3364 5.05437 5.39431 10.3015 5.39431C15.9984 5.39431 20.603 10.0006 20.603 15.6994C20.603 20.9484 16.6623 25.2976 11.5651 25.9189C12.0362 25.9617 12.5074 26.0046 13 26.0046C20.1746 26.0046 26 20.1771 26 13C26 5.8228 20.1746 -0.00463867 13 -0.00463867C5.82537 -0.00463867 0 5.80137 0 13Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany08);
export default __webpack_public_path__ + "static/media/company-08.aedf28a95b2180a22a96e533c84cece1.svg";
export { ForwardRef as ReactComponent };